import { render, staticRenderFns } from "./AspectPage.vue?vue&type=template&id=6eae9e7b&scoped=true&"
import script from "./AspectPage.vue?vue&type=script&lang=js&"
export * from "./AspectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eae9e7b",
  null
  
)

export default component.exports